module.exports = __webpack_public_path__ + "static/media/email-icon.4356accd.svg";